import { Component } from '@angular/core';
import { FeatureFlagService } from '@lsq-frontend/common-ui';
import { FeatureFlags } from '@lsq-frontend/fasttrack-shared/app-constants';
import { ManageSupplierService } from '../manage-supplier.service';

@Component({
    selector: 'manage-supplier-implementation',
    template: `
        <div class="manage-supplier-implementation row">
            <div
                class="col-12"
                [class.col-lg-8]="!(newManageSupplierImplementationTab$ | async)"
                [style.marginBottom]="'2rem'"
            >
                <lsq-circle-loader *ngIf="!(supplierRelationship$ | async)"></lsq-circle-loader>
                <supplier-implementation-summary-cards
                    *ngIf="
                        (newManageSupplierImplementationTab$ | async) &&
                        (supplierRelationship$ | async)
                    "
                >
                </supplier-implementation-summary-cards>

                <supplier-implementation-fee-structure *ngIf="supplierRelationship$ | async">
                </supplier-implementation-fee-structure>

                <supplier-implementation-buyer-fee
                    *ngIf="
                        (supplierPaidEarlyPaymentPercentage$ | async) &&
                        (supplierRelationship$ | async)
                    "
                ></supplier-implementation-buyer-fee>

                <supplier-implementation-transfer-fees
                    *ngIf="
                        (supplierPaidEarlyPaymentTransferFee$ | async) &&
                        (supplierRelationship$ | async)
                    "
                ></supplier-implementation-transfer-fees>

                <supplier-implementation-agreement *ngIf="supplierRelationship$ | async">
                </supplier-implementation-agreement>

                <supplier-implementation-enrollment-invite *ngIf="supplierRelationship$ | async">
                </supplier-implementation-enrollment-invite>
            </div>
            <div class="col-12 col-lg-4" *ngIf="!(newManageSupplierImplementationTab$ | async)">
                <data-card [lightBorder]="true">
                    <p class="header" [style.marginBottom]="'1rem'">Additional Information</p>
                    <p class="body text-dark-gray" [style.marginBottom]="'1rem'">
                        All facets of supplier implementation can be managed directly with the
                        settings on this page and should only be utilized by the Implementation
                        Team.
                    </p>
                    <p class="label" [style.marginBottom]="'1rem'">
                        When to Send an Enrollment Link
                    </p>
                    <p class="body text-dark-gray" [style.marginBottom]="'1rem'">
                        We recommend that at least 1 business week has passed before sending out a
                        new enrollment link to a new potential supplier. According to email
                        statistics, the most optimal day and time to send an email are Tuesdays at
                        10 AM, before lunchtime.
                    </p>
                </data-card>
            </div>
        </div>
    `
})
export class ManageSupplierImplementationComponent {
    public supplierRelationship$ = this._manageSupplierService.currentSupplierRelationship$;

    public newManageSupplierImplementationTab$ = this._featureFlagService.isOn(
        FeatureFlags.NewManageSupplierImplementationTab
    );

    public supplierPaidEarlyPaymentPercentage$ = this._featureFlagService.isOn(
        FeatureFlags.SupplierPaidEarlyPaymentPercentage
    );
    public supplierPaidEarlyPaymentTransferFee$ = this._featureFlagService.isOn(
        FeatureFlags.SupplierPaidEarlyPaymentTransferFee
    );

    constructor(
        private _manageSupplierService: ManageSupplierService,
        private _featureFlagService: FeatureFlagService
    ) {}
}
